export default __webpack_public_path__ + "static/media/small_arrow_circle_down.c96e7059.svg";